import React, { Component } from "react";
import { connect } from "react-redux";
import ComponentHeader from "../common/ComponentHeader";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button, Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import editPencil from "../../assets/images/edit-icon.png";
import { getAllPlaylistDataApi } from "./Api";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist, uploadFrequency } from "../../utils/Constant";
import { InformationModal, VerifiedModal } from "../common";
import { toast } from "react-toastify";
import { EVENT_VERIFY, PLAYLIST_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { deleteAuthCommonApi } from "../content/Api";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";


class Playlist extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.AutoSharePlaylist);

    this.state = {
      access: AccesData,
      search: "",
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,


      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''

    };
  }


  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllPlaylistDataApi(this);

  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllPlaylistDataApi(this);

      });
    }
  }

  getDetailsUser = (data) => {
    this.props.history({ pathname: `/playlist/details/${data?.uuid}`, state: { "id": data?.uuid, "detail": data } });
  }

  showEditModal = (rowData = null) => {
    // getDetailsApi("/playlist", this, rowData.uuid);
    this.props.history({ pathname: `/playlist/add-playlist`, state: { "id": rowData?.uuid } })
    this.setState({
      showEdit: !this.state.showEdit,

    });
  };

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };

  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/playlist/${id}`);
    // console.log(res)
    if (res.status === 200) {
      this.props.getAllPlaylistDataApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }

  render() {
    const { access } = this.state;

    const { playlistData, totalPages, currentPage } = this.props.autoShareState;
    // console.log(eventData)
    return (
      <>
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.title}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.title}'`}
          show={this.state.show}
          url={PLAYLIST_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllPlaylistDataApi(this) }}
        />
        <section>
          <ComponentHeader
            title="Playlist"
            primaryBtn={access.createAccess ? "Add Playlist" : ""}
            breadcrumb={[["Auto Share", ""], ["Playlist", ""]]}
            // isSearch={true}
            // isBackArrow={true}
            // isReturn="/contentCollections"
            handlePrimaryBtn={() => { this.props.history('/playlist/add-playlist') }}
            ctx={this}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
            ctx={this}
              data={playlistData?.list}
              columns={[
                {
                  width: 150,
                  title: "Title",
                  dataIndex: "title",
                  className: "title",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.title;
                  },
                },
                {
                  width: access.verificationAccess ? 120 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                   const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },
                {
                  width: 200,
                  title: "Content Creator",
                  dataIndex: "contentCreator",
                  className: "contentCreator",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.contentCreator?.contentCreatorName || 'Na';;
                    }
                },
                {
                  width: 150,
                  title: "AMC",
                  dataIndex: "amc",
                  className: "amc",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.amc?.amcName || 'Na';
                  },
                },
                {
                  width: 150,
                  title: "User",
                  dataIndex: "user",
                  className: "user",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return `${rowData?.user?.firstName || ''} ${rowData?.user?.lastName || ''}`.trim() || 'Na';

                  },
                },

                {
                  width: 150,
                  title: "Upload Frequency",
                  dataIndex: "uploadFrequency",
                  className: "uploadFrequency",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      // const searchValue = rowData.uploadFrequency == 0.00 ? 10 : rowData.uploadFrequency;
                      const frequency = uploadFrequency.find(item => item.value == rowData.uploadFrequency);
                      return frequency ? frequency.label : "";
                    }
                },

                {
                  width: 150,
                  title: "Thumbnail Image",
                  dataIndex: "thumbnailPath",
                  className: "",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return <Image src={rowData.thumbnailPath} className="table-img" alt="Photo" />;
                  },
                },


                {

                  width: 20,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  fixed: "right",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (
                        // <div className="d-flex justify-content-around gap-4">
                        //   <Button onClick={() => this.getDetailsUser(rowData)} className=" primary-btn ">
                        //     View
                        //   </Button>
                        //   {access.updateAccess && rowData?.isCustomized === false && (
                        //     <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                        //   )}
                        //   {access.deleteAccess && rowData?.isCustomized === false && (
                        //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                        //   )}
                        // </div>
                        <OptionsDropdown
                          editHandler={access.updateAccess && rowData?.isCustomized === false ? () => { this.showEditModal(rowData) } : null}
                          deleteHandler={access.deleteAccess && rowData?.isCustomized === false ? () => { this.openCloseDeleteModal(rowData) } : null}
                          viewHandler={() => this.getDetailsUser(rowData)}
                        />
                      );
                  },

                }

              ]}
             
              total={playlistData?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  autoShareState: state.AutoShareState,
});
const mapDispatchToProps = {
  getAllPlaylistDataApi,
  deleteAuthCommonApi

};
Playlist.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Playlist));
